import './LabelPartImage.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';

import { Typography } from '@material-ui/core';
import Logger from '@KrashidBuilt/common/utils/logger';

import utils from '../../utils';
import { LABEL_SIZE_MAP, FGT_REDIRECT_BASE, ENVIRONMENT } from '../../constants';

const logger = new Logger('LabelPartImage');

class LabelPartImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rotate: undefined,
            image: null
        };

    }

    setRotated = async (src) => {
        try {
            this.setState({ rotate: await utils.image.shouldRotate(src), image: src });
        } catch (error) {
            logger.error(error);
        }
    }

    componentDidMount() {
        const { image } = this.state;
        const { part } = this.props;

        if (part && part.file_url && !image) {
            this.setRotated(part.file_url);
        }

    }

    render() {
        const { size, qrDisabled, qrHintDisabled, hashId, part } = this.props;
        const { image, rotate } = this.state;

        const labelHeight = size === LABEL_SIZE_MAP._4x3 ? '1.58in' : '2.58in';

        return (
            image ?
                <div className={`LabelPartImageQrCodeContainer _${size}`} style={{ height: labelHeight }}>
                    <div className='LabelPartImageContainer'>
                        <img alt={'part'} className={`LabelPartImage ${rotate ? 'rotate' : ''} _${size}`} src={image} />
                    </div>
                    {/* if the feature is disabled by the user or the feature is disabled by post hog */}
                    {!qrDisabled &&
                        <div className={'QrCodeContainer'}>
                            {/* bigger label size for development because redirect url is massive */}
                            <QRCode size={ENVIRONMENT == 'development' ? 68 : 58} className={'QrCode'} value={`${FGT_REDIRECT_BASE}/${hashId}/${part?.id}`} />
                            {!qrHintDisabled &&
                                <div className='ScanMeMessage'>
                                    <Typography variant='caption'></Typography>
                                    <p className='ScanMeText'>
                                        Scan For All Parts
                                    </p>
                                </div>
                            }
                        </div>
                    }
                </div>
                :
                <div className={'PartNotFound'}>Part image not found</div>
        );
    }
}

LabelPartImage.defaultProps = {
};

LabelPartImage.propTypes = {
    size: PropTypes.string.isRequired,
    qrDisabled: PropTypes.bool,
    qrHintDisabled: PropTypes.bool,
    hashId: PropTypes.string,
    part: PropTypes.shape().isRequired,
};

export default LabelPartImage;